/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} World_Switcher_Error_RetryInputs */

const en_world_switcher_error_retry = /** @type {(inputs: World_Switcher_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const fr_world_switcher_error_retry = /** @type {(inputs: World_Switcher_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const ms_sg2_world_switcher_error_retry = /** @type {(inputs: World_Switcher_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuba semula`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {World_Switcher_Error_RetryInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const world_switcher_error_retry = /** @type {((inputs?: World_Switcher_Error_RetryInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<World_Switcher_Error_RetryInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_world_switcher_error_retry(inputs)
	if (locale === "fr") return fr_world_switcher_error_retry(inputs)
	return ms_sg2_world_switcher_error_retry(inputs)
});